<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2">Dedicated to</p>
<p class="ded"><em>Raechel</em></p>
<p class="ded"><em>Molly</em></p>
<p class="ded"><em>John</em></p>
<p class="ded"><em>David</em></p>
<p class="ded"><em>Travis</em></p>
<p class="ded"><em>Jonathan</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SadTaleoftheBr_dedi-1.vue?7c261962